export enum EUniteUR2 {
    UniteLente = 1,
    UniteEclairee = 2,
    RiveGauche = 3,
    Berge = 4,
    PeuProfonde = 5
}